export const DEFAULT_CLUSTERING_SENSITIVITY = 90
